import { useContext } from "react";
import { AttendanceContext } from "..";

export const useAttendanceContext = () => useContext(AttendanceContext);
